<template>
  <i18n-t :keypath="'NotificationsComponent.RFA_ExpiredSubscription'" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <a id="linkToRfaSupport" :href="getUrl('RFA_EXPIRED_SUPPORT')" target="_blank">
        {{ t("NotificationsComponent.ExpiredDestination") }}.
      </a>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { getUrl } from "@/common/getUrl";

const componentName = "RfaExpiredNotification";

export default defineComponent({
  name: componentName,
  setup() {
    logEvent("created", componentName);
    return { t, getUrl };
  },
});
</script>
